import React from 'react';
import PropTypes from "prop-types";
export default function Spacer(props) {
  var _props$mtop, _props$mright, _props$mbottom, _props$mleft, _props$ptop, _props$pright, _props$pbottom, _props$pleft;
  var style = {};
  style.marginTop = (_props$mtop = props.mtop) === null || _props$mtop === void 0 ? void 0 : _props$mtop.toString().concat('px');
  style.marginRight = (_props$mright = props.mright) === null || _props$mright === void 0 ? void 0 : _props$mright.toString().concat('px');
  style.marginBottom = (_props$mbottom = props.mbottom) === null || _props$mbottom === void 0 ? void 0 : _props$mbottom.toString().concat('px');
  style.marginLeft = (_props$mleft = props.mleft) === null || _props$mleft === void 0 ? void 0 : _props$mleft.toString().concat('px');
  style.paddingTop = (_props$ptop = props.ptop) === null || _props$ptop === void 0 ? void 0 : _props$ptop.toString().concat('px');
  style.paddingRight = (_props$pright = props.pright) === null || _props$pright === void 0 ? void 0 : _props$pright.toString().concat('px');
  style.paddingBottom = (_props$pbottom = props.pbottom) === null || _props$pbottom === void 0 ? void 0 : _props$pbottom.toString().concat('px');
  style.paddingLeft = (_props$pleft = props.pleft) === null || _props$pleft === void 0 ? void 0 : _props$pleft.toString().concat('px');
  return /*#__PURE__*/React.createElement("div", {
    style: style
  }, props.children);
}
Spacer.propTypes = {
  mtop: PropTypes.number,
  mbottom: PropTypes.number,
  mleft: PropTypes.number,
  mright: PropTypes.number,
  ptop: PropTypes.number,
  pbottom: PropTypes.number,
  pleft: PropTypes.number,
  pright: PropTypes.number
};